import { MultilingualFactory } from '../../common';
export class ManfrediteBookmarkFactory {
    static create(props = {}) {
        const defaultProps = {
            id: 1,
            type: 'WEBSITE',
            title: MultilingualFactory.create()
        };
        return { ...defaultProps, ...props };
    }
    static createList(length = 1) {
        return Array.from({ length }).map(() => this.create());
    }
}
//# sourceMappingURL=manfredite-bookmark.factory.js.map